"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfAdminChatRequestDto = instanceOfAdminChatRequestDto;
exports.AdminChatRequestDtoFromJSON = AdminChatRequestDtoFromJSON;
exports.AdminChatRequestDtoFromJSONTyped = AdminChatRequestDtoFromJSONTyped;
exports.AdminChatRequestDtoToJSON = AdminChatRequestDtoToJSON;
exports.AdminChatRequestDtoToJSONTyped = AdminChatRequestDtoToJSONTyped;
const ChatMessageDto_1 = require("./ChatMessageDto");
/**
 * Check if a given object implements the AdminChatRequestDto interface.
 */
function instanceOfAdminChatRequestDto(value) {
    if (!('messages' in value) || value['messages'] === undefined)
        return false;
    return true;
}
function AdminChatRequestDtoFromJSON(json) {
    return AdminChatRequestDtoFromJSONTyped(json, false);
}
function AdminChatRequestDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'messages': (json['messages'].map(ChatMessageDto_1.ChatMessageDtoFromJSON)),
    };
}
function AdminChatRequestDtoToJSON(json) {
    return AdminChatRequestDtoToJSONTyped(json, false);
}
function AdminChatRequestDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'messages': (value['messages'].map(ChatMessageDto_1.ChatMessageDtoToJSON)),
    };
}
//# sourceMappingURL=AdminChatRequestDto.js.map